import styled from 'styled-components';
export const GdprContainer = styled.div `
  width: 100%;
  padding: 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.grey15};
  & button {
    width: 100%;
  }
  min-height: ${({ minHeight }) => `${minHeight}px`};
  &&& a {
    align-items: center;
  }
  &&& a span:first-of-type {
    position: unset;
    position: unset;
  }
  &&&& a span:last-of-type {
    border-top: 1px solid transparent;
    margin-left: 0.375rem;
  }
`;
export const GdpgButtonWrapper = styled.div `
  flex: 1%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 2rem;
`;
